import BrandRuleEditor from './BrandRuleEditor';

const BrandAllowlist = () => <BrandRuleEditor ruleType='brand_allowlist' label='Allowed brands' />;

export default BrandAllowlist;
